import { render, staticRenderFns } from "./InvoiceResult.vue?vue&type=template&id=bf2eefd2"
import script from "./InvoiceResult.vue?vue&type=script&lang=js"
export * from "./InvoiceResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports